import {SIGN_IN, SIGN_OUT} from '../../actions/generic/types';
import {getToken, getUser} from '../../storage/sessionStorage';
import _ from 'lodash';

const INITIAL_STATE = {
    isSignedIn: !_.isEmpty(getToken()),
    user: getUser(),
    token: getToken()
}

// const INITIAL_STATE = {
//     isSignedIn: false,
//     user: {},
//     token: null
// }

export default (state = INITIAL_STATE, action) => {
    switch(action.type){
        case SIGN_IN:
            return {...state, isSignedIn: !_.isEmpty(action.payload.user), user: action.payload.user, token: action.payload.token, authError:action.payload.authError};
        case SIGN_OUT:
            return {...state, isSignedIn: false, user: null, token: null};
        default:
            return state;
    }
}